import Vue from 'vue';
import {
  onSnapshot,
  firestoreCollection,
  firestoreDocumentById,
  update,
} from '../firebase/firestore';
import { types as userTypes } from './user';
import { MUTATION_REGISTER_SNAPSHOT_LISTENER } from './constants';

const MODULE_PREFIX = 'notifications';
const GETTER_NOTVIEWED_NOTIFICATION_COUNT = 'notViewedNotificationCount';
const GETTER_NOTIFICATIONS = 'notifications';
const ACTION_FETCH_NOTIFICATIONS = 'fetchNotifications';
const ACTION_MARK_NOTIFICATION_AS_CLICKED = 'markNotificationAsClicked';
const ACTION_MARK_NOTIFICATION_AS_SILENCED = 'markNotificationAsSilenced';
const ACTION_MARK_ALL_DISPLAYED = 'markAllDisplayed';
const ACTION_MARK_ALL_SILENCED = 'markAllSilenced';
const MUTATION_RECEIVED_NOTIFICATION = 'RECEIVED_NOTIFICATION';

export const STATUS = {
  created: 'created',
  displayed: 'displayed',
  clicked: 'clicked',
  silenced: 'silenced',
};

const initialState = {
  notifications: [],
  notificationCount: 0,
};

const getters = {
  [GETTER_NOTVIEWED_NOTIFICATION_COUNT]: state => state.notificationCount,
  [GETTER_NOTIFICATIONS]: state => state.notifications,
};

const mutations = {
  [MUTATION_RECEIVED_NOTIFICATION]: (state, notifications) => {
    Vue.set(state, 'notifications', notifications);
    Vue.set(state, 'notificationCount', notifications.filter(notif =>
      (notif.metadata.status === STATUS.created || notif.metadata.status === STATUS.displayed)).length);
  },
};

const receiveNotification = (commit, snapshot) => {
  const notifications = [];

  snapshot.docs.forEach(notification => {
    notifications.push({
      id: notification.id,
      ...notification.data(),
    });
  });

  commit(MUTATION_RECEIVED_NOTIFICATION, notifications);
};

const actions = {
  [ACTION_FETCH_NOTIFICATIONS]: async ({ commit, rootGetters }) => {
    const userId = rootGetters[userTypes.getters.userId];
    const snapshotListener = onSnapshot(
      firestoreCollection('notifications')
        .where('userId', '==', userId)
        .where('metadata.status', 'in', [STATUS.created, STATUS.displayed, STATUS.clicked, STATUS.silenced])
        .orderBy('metadata.timestamp', 'desc')
        .limit(10),
      receiveNotification.bind(this, commit),
    );
    commit(
      MUTATION_REGISTER_SNAPSHOT_LISTENER,
      { snapshotListener, id: 'notifications' },
      { root: true },
    );
  },
  [ACTION_MARK_NOTIFICATION_AS_CLICKED]: async (_, { notificationId }) => {
    await update(firestoreDocumentById('notifications', notificationId), { 'metadata.status': STATUS.clicked });
  },
  [ACTION_MARK_NOTIFICATION_AS_SILENCED]: async (_, { notificationId }) => {
    await update(firestoreDocumentById('notifications', notificationId), { 'metadata.status': STATUS.silenced });
  },
  [ACTION_MARK_ALL_SILENCED]: async ({ state }) => {
    const promises = [];
    state.notifications.forEach(notification => {
      if (notification.metadata.status === STATUS.created || notification.metadata.status === STATUS.displayed) {
        const updatePromise = update(firestoreDocumentById('notifications', notification.id), {
          'metadata.status': STATUS.silenced,
        });
        promises.push(updatePromise);
      }
    });
    await Promise.all(promises);
  },
  [ACTION_MARK_ALL_DISPLAYED]: async ({ state }) => {
    const promises = [];
    state.notifications.forEach(notification => {
      if (notification.metadata.status === STATUS.created) {
        const updatePromise = update(firestoreDocumentById('notifications', notification.id), {
          'metadata.status': STATUS.displayed,
        });
        promises.push(updatePromise);
      }
    });
    await Promise.all(promises);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    notViewedNotificationCount: `${MODULE_PREFIX}/${GETTER_NOTVIEWED_NOTIFICATION_COUNT}`,
    notifications: `${MODULE_PREFIX}/${GETTER_NOTIFICATIONS}`,
  },
  actions: {
    fetchNotifications: `${MODULE_PREFIX}/${ACTION_FETCH_NOTIFICATIONS}`,
    markNotificationAsClicked: `${MODULE_PREFIX}/${ACTION_MARK_NOTIFICATION_AS_CLICKED}`,
    markNotificationAsSilenced: `${MODULE_PREFIX}/${ACTION_MARK_NOTIFICATION_AS_SILENCED}`,
    markAllDisplayed: `${MODULE_PREFIX}/${ACTION_MARK_ALL_DISPLAYED}`,
    markAllSilenced: `${MODULE_PREFIX}/${ACTION_MARK_ALL_SILENCED}`,
  },
};
